import{createSelector}from'reselect';/**
 * Returns url state (state.url)
 * @param {Object} state The application state.
 * @returns {Object}
 */export var getUrlState=function getUrlState(state){return state.url;};/**
 * Returns the complete state entry for state.url[type]
 * @param {string} type The url type.
 * @param {Object} state The application state.
 * @returns {Object|undefined}
 */export var getEntryByType=createSelector(getUrlState,function(state,_ref){var type=_ref.type;return type;},function(urlState,type){if(!urlState||!urlState[type]){return null;}return urlState[type];});/**
 * Returns the url for the given url type.
 * @param {string} type The url type.
 * @param {Object} state The application state.
 * @returns {string|null}
 */export var getUrl=createSelector(getEntryByType,function(entry){if(!entry){return null;}return entry.url;});